import { styled } from '@mui/material';
import { CoreBox } from '@youscience/core';

export const StyledJustifiedBox = styled(CoreBox)(({ theme }) => ({
  display: 'flex',
  alignSelf: 'stretch',
  alignItems: 'center',
  alignContent: 'flex-start',
  justifyContent: 'space-between',
  flexDirection: 'row',

  [theme.breakpoints.down('md')]: {
    alignItems: 'flex-start',
    flexDirection: 'column',
  },
}));

export const StyledTeacher = styled(CoreBox)(({ theme }) => ({
  display: 'flex',
  alignSelf: 'stretch',
  alignItems: 'top',
  alignContent: 'flex-start',
  justifyContent: 'space-between',
  flexDirection: 'row',
  gap: '1rem',

  [theme.breakpoints.down('md')]: {
    alignSelf: 'flex-start',
    marginBottom: '1rem',
  },
}));

export const StyledTeacherButtonGroup = styled(CoreBox)(({ theme }) => ({
  display: 'flex',
  gap: '0.25rem',

  [theme.breakpoints.down('md')]: {
    alignSelf: 'stretch',
  },
}));

export const StyledTeacherCountGroup = styled(CoreBox)(({ theme }) => ({
  display: 'flex',
  gap: '2rem',
}));
